import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Typography, Stack} from 'views/components';
import {Accordion, AccordionDetails, AccordionSummary} from 'views/components';

import {Translate} from 'views/module';

import ClientLeadContacts from './client_lead_contact/ClientLeadContacts';


const ClientLeadSettings = (props) => {
  const clientLeadRn = props.clientLeadRn;
  const clientLeadData = props.clientLeadData;
  const clientLeadBackend = props.clientLeadBackend;

  const view = props.clientLeadSettingsView;
  const setView = props.setClientLeadSettingsView;

  const handleChange = (panel) => (event, isExpanded) => {
    setView(isExpanded ? panel : '');
  };

  return (
    <Stack
      spacing={2}
      sx={{
        mr: 2,
      }}
    >
      <Accordion
        expanded={view === 'CONTACT'}
        onChange={handleChange('CONTACT')}
        sx={{marginBottom: '16px'}}
        TransitionProps={{unmountOnExit: true}}
        disableGutters
      >
        <AccordionSummary
          sx={{
            'flexDirection': 'row-reverse',
            '& .MuiAccordionSummary-content': {
              marginLeft: '8px',
            },
            '&.Mui-expanded': {
              minHeight: '0px',
            },
            'borderBottom': '1px solid rgba(0, 0, 0, 0.12)',
            'textTransform': 'uppercase',
          }}
        >
          <Typography sx={{textTransform: 'uppercase', fontWeight: 500, color: 'black'}}>
            <Translate expression='clientLead.ClientLeadDetail.Settings.Contact.Title'/>
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            paddingTop: '8px',
            paddingBottom: '0px',
            overflow: 'auto',
          }}
        >
          <ClientLeadContacts
            clientLeadRn={clientLeadRn}
            clientLeadData={clientLeadData}
            clientLeadBackend={clientLeadBackend}
          />
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
};

ClientLeadSettings.propTypes = {
  clientLeadRn: PropTypes.string.isRequired,
  clientLeadData: PropTypes.object.isRequired,
  clientLeadBackend: PropTypes.object.isRequired,
  clientLeadSettingsView: PropTypes.string.isRequired,
  setClientLeadSettingsView: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(ClientLeadSettings));
